import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
export function App() {
  return <Routes data-id="element-0">
      <Route path="/" element={<Home data-id="element-2" />} data-id="element-1" />
      <Route path="/cookie-policy" element={<CookiePolicy data-id="element-4" />} data-id="element-3" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" />} data-id="element-5" />
      <Route path="/terms" element={<TermsAndConditions data-id="element-8" />} data-id="element-7" />
      <Route path="/disclaimer" element={<Disclaimer data-id="element-10" />} data-id="element-9" />
      <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
      <Route path="/faq" element={<FAQ data-id="element-14" />} data-id="element-13" />
    </Routes>;
}